// CabinetMembers — ÉCRAN 4 de la maquette : « Choisissez votre interlocuteur » (v5.20.0).
// Cartes compactes : avatar · nom + statut · fonction · spécialités · Voir profil.
import { useState } from "react";
import { T, PhotoAvatar, StatusPill } from "./cabinetTheme";

export const CabinetMembers = ({ members, qualification, onSelect, onProfile }) => {
  const recId = qualification?.recommended_member_id || null;
  const domain = qualification?.domain || null;
  const [filter, setFilter] = useState("all");

  const sorted = recId ? [...members.filter((m) => m.member_id === recId), ...members.filter((m) => m.member_id !== recId)] : members;
  const shown = sorted.filter((m) => {
    if (filter === "dispo") return m.availability !== "visio";
    if (filter === "domain") return (m.specialties || []).some((s) => domain && s.toLowerCase().includes(domain.toLowerCase().replace("droit ", "")));
    return true;
  });

  const chips = [["all", "Tous"], ["dispo", "Disponible"], ...(domain ? [["domain", domain]] : [])];

  return (
    <div style={{ display: "grid", gap: 10 }} data-testid="cabinet-members">
      <div>
        <h2 style={{ ...T.h1, fontSize: 18 }}>Choisissez votre interlocuteur</h2>
        <p style={{ ...T.sub, margin: "3px 0 0" }}>Selon votre besoin, vous pouvez parler à un membre de notre équipe.</p>
      </div>
      <div style={{ display: "flex", gap: 7, overflowX: "auto", scrollbarWidth: "none" }}>
        {chips.map(([v, l]) => (
          <button key={v} onClick={() => setFilter(v)} data-testid={`members-filter-${v}`}
            style={{ ...T.chip, cursor: "pointer", ...(filter === v ? { background: "#065F46", color: "#fff", border: "1px solid #065F46" } : {}) }}>{l}</button>
        ))}
      </div>
      {shown.map((m) => (
        <div key={m.member_id} onClick={() => onSelect(m)} role="button" data-testid={`member-card-${m.member_id}`}
          style={{ ...T.card, display: "flex", gap: 11, cursor: "pointer", padding: "12px 13px" }}>
          <PhotoAvatar member={m} size={46} />
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: 6 }}>
              <span style={{ fontSize: 13.5, fontWeight: 900 }}>
                {m.name}
                {m.member_id === recId && <span style={{ ...T.badge, ...T.badgeOrange, marginLeft: 6 }}>Recommandé</span>}
                {m.is_demo && <span style={{ ...T.badge, ...T.badgeDemo, marginLeft: 6 }}>DEMO</span>}
              </span>
              <StatusPill availability={m.availability} />
            </div>
            <div style={{ ...T.sub, fontSize: 12, marginTop: 1 }}>{m.title}</div>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-end", marginTop: 3 }}>
              <span style={{ ...T.sub, fontSize: 11.5 }}>{(m.specialties || []).join(" • ")}</span>
              <button onClick={(e) => { e.stopPropagation(); (onProfile || onSelect)(m); }} data-testid={`member-profile-${m.member_id}`}
                style={{ background: "none", border: "none", padding: 0, color: "#0E8A4F", fontSize: 11.5, fontWeight: 800, whiteSpace: "nowrap", cursor: "pointer" }}>Voir profil</button>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};
